import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import appReducer from './app';
import { reduxLogger } from '../middleware/redux-logger';
import { gaAnalytics } from '../middleware/ga-analytics';

export function configure(ctrl) {
  return configureStore({
    reducer: {
      app: appReducer,
    },
    middleware: [
      ...getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }),
      // gaAnalytics(ctrl),
      reduxLogger,
    ],
  });
}
